import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import api from '../api/client';

export default function Login() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  // すでにログイン済みならトップへ
  const existing = localStorage.getItem('access');
  if (existing) return <Navigate to="/" replace />;

  const onChange = (e) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      // SimpleJWT: /api/auth/token/
      const res = await api.post('/api/auth/token/', {
        username: form.username.trim(),
        password: form.password,
      });
      const { access, refresh } = res.data || {};
      if (access && refresh) {
        localStorage.setItem('access', access);
        localStorage.setItem('refresh', refresh);
        navigate('/', { replace: true });
      } else {
        setErr('ログインに失敗しました（トークンなし）。');
      }
    } catch (error) {
      const status = error?.response?.status;
      const detail = error?.response?.data?.detail ?? (typeof error?.response?.data === 'string' ? error.response.data : '');
      const msg =
        status === 401 || status === 400
          ? (Array.isArray(detail) ? detail[0] : detail) || 'ユーザー名またはパスワードが正しくありません。'
          : `ログインでエラーが発生しました（${status || ''} ${error?.message || ''}）。`;
      setErr(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrap}>
      <form onSubmit={onSubmit} style={styles.card}>
        <h1 style={{ marginBottom: 16, fontSize: 22 }}>ログイン</h1>
        <label style={styles.label}>
          社員番号（社員マスターのコード）
          <input
            name="username"
            type="text"
            value={form.username}
            onChange={onChange}
            placeholder="例: S002"
            style={styles.input}
            autoComplete="username"
            required
          />
        </label>
        <label style={styles.label}>
          パスワード
          <input
            name="password"
            type="password"
            value={form.password}
            onChange={onChange}
            placeholder="********"
            style={styles.input}
            autoComplete="current-password"
            required
          />
        </label>
        {err && <div style={styles.error}>{err}</div>}
        <button type="submit" style={styles.button} disabled={loading}>
          {loading ? 'ログイン中…' : 'ログイン'}
        </button>
      </form>
    </div>
  );
}
const styles = {
  wrap: {
    minHeight: '100vh',
    display: 'grid',
    placeItems: 'center',
    background: '#f7f7fb',
    padding: 24,
  },
  card: {
    width: 360,
    maxWidth: '90vw',
    background: '#fff',
    borderRadius: 16,
    boxShadow: '0 10px 30px rgba(0,0,0,0.06)',
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  label: { display: 'flex', flexDirection: 'column', gap: 6, fontSize: 14 },
  input: {
    height: 40,
    padding: '0 12px',
    border: '1px solid #e5e7eb',
    borderRadius: 10,
    outline: 'none',
  },
  button: {
    marginTop: 8,
    height: 42,
    borderRadius: 10,
    background: '#2563eb',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    fontWeight: 600,
  },
  error: {
    background: '#fee2e2',
    color: '#991b1b',
    border: '1px solid #fecaca',
    padding: '8px 10px',
    borderRadius: 8,
    fontSize: 13,
  },
};

